import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Table, Button, Tooltip } from 'antd';
import './styles.css';

const { Column } = Table;

const ReservationsForUserDNITable = ({ data, reserveSelected }) => {

    return (
        <Table className="reservationsForUserDNITableCont" dataSource={data} rowKey="reserveID" size="small" pagination={true}>
            <Column className="dateCont" title="Fecha de la reserva" dataIndex="date" key="date" align="center" />
            <Column className="hourCont" title="Hora de la reserva" dataIndex="hour" key="hour" align="center" />
            <Column className="checkInCont" title="Ingreso" dataIndex="checkIn" key="checkIn" align="center" />
            <Column className="checkOutCont" title="Egreso" dataIndex="checkOut" key="checkOut" align="center" />
            <Column className="temperatureCont" title="Temperatura" dataIndex="temperature" key="temperature" align="center"
            render={(text, record) => {
                return(
                    <span>{record.temperature !== "" ? `${record.temperature}ºC` : "--"}</span>
                )
            }}/>
            <Column title="" dataIndex="details" key="details" align="center"
                render={(text, record) => (
                    <Button type="primary" onClick={() => reserveSelected(record.reserveID)}>Ver reserva</Button>
                )}
            />
        </Table>
    );
};

ReservationsForUserDNITable.propTypes = {
    data: PropTypes.array,
};

export default ReservationsForUserDNITable;